import React, { useState, useEffect } from "react";
import { Container, Card, Row, Col, Modal } from "react-bootstrap";
import "../../../asset/css/inbox.css";
import $ from "jquery";
import "datatables.net";
import "datatables.net-dt/css/jquery.dataTables.css";
import NoDataImage from "../../../asset/images/nodata.jpg";
import { BASE_URL } from "../CommonApi";
import swal from "sweetalert";
import { AES, enc } from "crypto-js";
import Alert from "@mui/material/Alert";
import HRSEmployeeUpdate from "./HRSEmployeeUpdate";
import EmployeeDetails from "./EmployeeDetails";
import EmployeeAccess from "./EmployeeAccess";
import EmployeeProfile from "./EmployeeProfile";

function HRSEmployeeCard({ navigation }) {
  const [employeeData, setEmployeeData] = useState([]);
  const [newItem, setnewItem] = useState([]);
  const [itemId, setItemID] = useState("");
  const [loading, setLoading] = useState(false);
  const [showCard, setShowCard] = useState(true);
  const [showUpdate, setShowUpdate] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [showSalesModal, setShowSalesModal] = useState(false);
  const [showEmpAccess, setShowEmpAccess] = useState(false);
  const [showEmpProfile, setShowEmpProfile] = useState(false);

  const handleNavigation = (key) => {
    if (navigation.state.routes[navigation.state.index].key !== key) {
      navigation.navigate(key);
    }
  };
  const handleItemsClick = () => {
    handleNavigation("HRSEmployee");
  };

  const encryptedUniqueId = localStorage.getItem("uniqueId1");
  const decryptedUniqueId = AES.decrypt(
    encryptedUniqueId,
    "1234567812345678"
  ).toString(enc.Utf8);
  const jwtToken = localStorage.getItem("jwtToken");

  const handleEdit = (id) => {
    setItemID(id);
    setShowCard(false);
    setShowUpdate(true);
    setShowEmpAccess(false);
    setShowEmpProfile(false);
  };

  const handleEmpAccessClick = (id) => {
    setItemID(id);
    setShowCard(false);
    setShowUpdate(false);
    setShowEmpAccess(true);
    setShowEmpProfile(false);
  };

  const handleEmpProfile = (id) => {
    setItemID(id);
    setShowCard(false);
    setShowUpdate(false);
    setShowEmpAccess(false);
    setShowEmpProfile(true);
  };

  const handleDelete = (id) => {
    const userConfirmed = window.confirm(
      "Are you sure? Once deleted, you will not be able to recover this item!"
    );
    const jwtToken = localStorage.getItem("jwtToken");

    if (userConfirmed) {
      setLoading(true);
      // If the user clicks "OK", proceed with the deletion
      fetch(BASE_URL + `/deleteHrsDataById`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
        body: JSON.stringify({ id: String(id) }), // Ensure id is sent as a string
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === "200") {
            setLoading(false);
            // Remove the deleted item from the local state
            setEmployeeData((prevItems) =>
              prevItems.filter((employeeDatas) => employeeDatas.id !== id)
            );

            swal({
              icon: "success",
              title: "Item Deleted Successfully",
            });
            fetchEmployeeData();
          } else if (
            data.responseMessage ===
            "Items which are a part of other transactions cannot be deleted. Instead, mark them as inactive."
          ) {
            setLoading(false);
            window.confirm(
              "Items which are a part of other transactions cannot be deleted!"
            );
          } else {
            setLoading(false);
            console.error("Failed to delete Item");
          }
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error deleting Item:", error);
        });
    } else {
      setLoading(false);
      // If the user clicks "Cancel", do nothing
      alert("Item deletion canceled!");
    }
  };

  const handleCancelUpdate = () => {
    fetchEmployeeData();
    setShowUpdate(false);
    setShowCard(true);
    setShowEmpAccess(false);
  };

  const handleCancelDetails = () => {
    setShowDetails(false);
    setShowCard(true);
    fetchEmployeeData();
    setShowUpdate(false);
    setShowEmpAccess(false);
  };

  const handleCancelAccessPage = () => {
    setShowCard(true);
    setShowDetails(false);
    setShowEmpAccess(false);
    fetchEmployeeData();
    setShowUpdate(false);
  };

  const handleCancelEmpProfile = () => {
    setShowEmpProfile(false);
    fetchEmployeeData();
    setShowUpdate(false);
    setShowEmpAccess(false);
    setShowCard(true);
  };

  const fetchAccessData = async () => {
    const accessResponse = await fetch(
      `https://trading.zarpsoftware.in/jps/JpserpApi/get_emp_menu/${decryptedUniqueId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
      }
    );
    const accessData = await accessResponse.json();
    if (accessResponse.ok && accessData.status === "success") {
      const accessRights = accessData.message;

      // Update the accessOptions based on the API response
      console.log("Access Rights:", accessRights);
    }
  };

  const fetchEmployeeData = () => {
    $("#DataTables_Table_0").DataTable();

    const encryptedUniqueId = localStorage.getItem("uniqueId1");
    const decryptedUniqueId = AES.decrypt(
      encryptedUniqueId,
      "1234567812345678"
    ).toString(enc.Utf8);
    const jwtToken = localStorage.getItem("jwtToken");

    const postApiUrl = BASE_URL + `/getHrsEmpDataByUniqueId`;

    setLoading(true);
    fetch(postApiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ uniqueId: decryptedUniqueId }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Employee Data:", data);
        if (data.status === "success") {
          setLoading(false);
          setEmployeeData(data.data);
        } else {
          setLoading(false);
          console.error("Failed to fetch employees:", data.data);
        }
        // setLoading(false);
        $("#DataTables_Table_0").DataTable();
      })
      .catch((error) => {
        console.error("Error making POST request:", error);
        setLoading(false);
        $("#DataTables_Table_0").DataTable();
      });
  };

  useEffect(() => {
    fetchEmployeeData();
    fetchAccessData();
  }, []);

  let i = 1;

  const handleItem = (name, id) => {
    setItemID(id);
    setnewItem(name);
    setShowDetails(true);
    setShowCard(false);
    setShowUpdate(false);
  };

  if (loading) {
    return (
      <div className="container-fluid ">
        <div className="page-content">
          <div className="center-div">
            <div className="spinner"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      {!showUpdate && !showDetails && !showEmpAccess && !showEmpProfile && (
        <div className="item-page">
          <div className="d-flex justify-content-between">
            <div
              className="mt-2"
              style={{
                color: "#3C7BD4",
                fontSize: 20,
                fontWeight: "600",
                wordWrap: "break-word",
                textAlign: "left",
              }}
            >
              Employee
            </div>
            <div className="button-container d-flex">
              {/* <button
                className="btn btn-primary px-1 py-2 mx-2"
                onClick={() => handleEmpProfile(employeeData?.id)}
              >
                Employee Profile
              </button>
              <button
                className="btn btn-primary px-1 py-2 mx-2"
                onClick={() => handleEmpAccessClick(employeeData?.id)}
              >
                Employee Access
              </button> */}
              <button
                className="btn btn-primary px-1 py-2 new-button"
                onClick={handleItemsClick}
              >
                + Employee
              </button>
            </div>
          </div>
        </div>
      )}
      {showCard && (
        <div
          className="container-fluid"
          style={{ border: "none", borderRadius: "7px" }}
        >
          <div className="page-content ">
            <Container fluid={true} className="">
              <Row>
                <Col>
                  <Card style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
                    {employeeData && employeeData.length > 0 ? (
                      <>
                        <div className="body">
                          <div className="table-responsive1">
                            <div
                              id="DataTables_Table_0_wrapper"
                              className="dataTables_wrapper dt-bootstrap4 no-footer"
                            >
                              <div className="row">
                                <div className="col-sm-12">
                                  <table
                                    className="table table-hover js-basic-example dataTable table-custom mb-0 no-footer"
                                    id="DataTables_Table_0"
                                    role="grid"
                                    aria-describedby="DataTables_Table_0_info"
                                  >
                                    <thead className="heading-text">
                                      <tr role="row">
                                        <th
                                          className="sorting_asc"
                                          tabIndex="0"
                                          aria-controls="DataTables_Table_0"
                                          rowSpan="1"
                                          colSpan="1"
                                          aria-sort="ascending"
                                          aria-label="Date: activate to sort column descending"
                                        >
                                          Serial no.
                                        </th>
                                        <th
                                          className="sorting"
                                          tabIndex="0"
                                          aria-controls="DataTables_Table_0"
                                          rowSpan="1"
                                          colSpan="1"
                                          aria-label="Type: activate to sort column ascending"
                                        >
                                          Employee Name
                                        </th>
                                        <th
                                          className="sorting"
                                          tabIndex="0"
                                          aria-controls="DataTables_Table_0"
                                          rowSpan="1"
                                          colSpan="1"
                                          aria-label="Amount BTC: activate to sort column ascending"
                                        >
                                          Contact No.
                                        </th>
                                        <th
                                          className="sorting"
                                          tabIndex="0"
                                          aria-controls="DataTables_Table_0"
                                          rowSpan="1"
                                          colSpan="1"
                                          aria-label="BTC Remaining: activate to sort column ascending"
                                        >
                                          Email
                                        </th>
                                        <th
                                          className="sorting"
                                          tabIndex="0"
                                          aria-controls="DataTables_Table_0"
                                          rowSpan="1"
                                          colSpan="1"
                                          aria-label="Price: activate to sort column ascending"
                                        >
                                          Actions
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody className="text1">
                                      {employeeData.map((data) => (
                                        <tr
                                          role="row"
                                          className="odd"
                                          key={data.id}
                                        >
                                          <td>{i++}</td>
                                          <td className="sorting_1">
                                            {" "}
                                            <a
                                              href="#"
                                              onClick={() =>
                                                handleItem(data.name, data.id)
                                              }
                                            >
                                              {data.name}
                                            </a>
                                          </td>
                                          <td>{data.contactNumber}</td>
                                          <td>{data.personalEmail}</td>

                                          <td>
                                            <button
                                              className="btn icon-border btn-sm mr-2"
                                              onClick={() =>
                                                handleEdit(data.id)
                                              }
                                            >
                                              <i className="fa fa-edit text1"></i>
                                            </button>
                                            <button
                                              className="btn icon-border btn-sm mr-2"
                                              onClick={() =>
                                                handleDelete(data.id)
                                              }
                                            >
                                              <i className="fa fa-trash text1"></i>
                                            </button>
                                            <button
                                              className="btn icon-border btn-sm mr-2"
                                              onClick={() =>
                                                handleEmpAccessClick(data?.id)
                                              }
                                            >
                                              <i className="fa fa-key text1"></i>
                                            </button>
                                            <button
                                              className="btn icon-border btn-sm"
                                              onClick={() =>
                                                handleEmpProfile(data?.id)
                                              }
                                            >
                                              <i className="fa fa-user-circle text1"></i>
                                            </button>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="body">
                        <div className="table-responsive1">
                          <div
                            id="DataTables_Table_0_wrapper"
                            className="dataTables_wrapper dt-bootstrap4 no-footer"
                          >
                            <div className="row">
                              <div className="col-sm-12">
                                <table
                                  className="table table-hover js-basic-example dataTable table-custom mb-0 no-footer"
                                  id="DataTables_Table_0"
                                  role="grid"
                                  aria-describedby="DataTables_Table_0_info"
                                >
                                  <thead className="heading-text">
                                    <tr role="row">
                                      <th
                                        className="sorting_asc"
                                        tabIndex="0"
                                        aria-con
                                        trols="DataTables_Table_0"
                                        rowSpan="1"
                                        colSpan="1"
                                        aria-sort="ascending"
                                        aria-label="Date: activate to sort column descending"
                                      >
                                        Serial no.
                                      </th>
                                      <th
                                        className="sorting"
                                        tabIndex="0"
                                        aria-controls="DataTables_Table_0"
                                        rowSpan="1"
                                        colSpan="1"
                                        aria-label="Type: activate to sort column ascending"
                                      >
                                        Employee Name
                                      </th>
                                      <th
                                        className="sorting"
                                        tabIndex="0"
                                        aria-controls="DataTables_Table_0"
                                        rowSpan="1"
                                        colSpan="1"
                                        aria-label="Amount BTC: activate to sort column ascending"
                                      >
                                        Contact No.
                                      </th>
                                      <th
                                        className="sorting"
                                        tabIndex="0"
                                        aria-controls="DataTables_Table_0"
                                        rowSpan="1"
                                        colSpan="1"
                                        aria-label="BTC Remaining: activate to sort column ascending"
                                      >
                                        Email
                                      </th>
                                      <th
                                        className="sorting"
                                        tabIndex="0"
                                        aria-controls="DataTables_Table_0"
                                        rowSpan="1"
                                        colSpan="1"
                                        aria-label="Price: activate to sort column ascending"
                                      >
                                        Date Of Joining
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody></tbody>
                                </table>
                                <h6 className="text-center">
                                  <img
                                    src={NoDataImage}
                                    style={{ width: "50%", height: "50%" }}
                                    alt="No Data Logo"
                                  />{" "}
                                </h6>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      )}

      {showUpdate && (
        <HRSEmployeeUpdate id={itemId} onCancel={handleCancelUpdate} />
      )}

      {showDetails && (
        <EmployeeDetails id={itemId} onCancel={handleCancelDetails} />
      )}

      {showEmpAccess && (
        <EmployeeAccess id={itemId} onCancel={handleCancelAccessPage} />
      )}

      {showEmpProfile && (
        <EmployeeProfile id={itemId} onCancel={handleCancelEmpProfile} />
      )}
    </div>
  );
}

export default HRSEmployeeCard;
